import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class VideosService {

  //declare variables
  private videos: any[] = [
    {
      title: 'Regulator Modules',
      description: 'This video explains catalogues and security profiles in RegScale.',
      url: 'https://www.youtube.com/embed/av-Zpo2wPnU',
      roles: 'auditor, practicioner'
    },
    {
      title: 'Homepage',
      description: 'This video explains the RegScale homepage and the various tools available to use there.  ',
      url: 'https://www.youtube.com/embed/pv5lRZcgZho',
      roles: 'auditor, practicioner'
    },
    {
      title: 'Status Boards',
      description: 'This video explains the various Status Boards and how to use them in RegScale.',
      url: 'https://www.youtube.com/embed/8UGPtBNqpy4',
      roles: 'executive'
    },
    {
      title: 'Setup Module',
      description: 'This video explains how to do your initial setup and configuration in RegScale.',
      url: 'https://www.youtube.com/embed/QbYgzJT2hOs',
      roles: 'admin'
    },
    {
      title: 'Policy Module',
      description: 'This video explains how to use the policies module in RegScale.',
      url: 'https://www.youtube.com/embed/1ZAD2V_hp6k',
      roles: 'auditor, practicioner'
    },
    {
      title: 'Supply Chain Module ',
      description: 'This video explains how to use the Supply Chain module in RegScale.',
      url: 'https://www.youtube.com/embed/jGUMId1lQ8w',
      roles: 'auditor, practicioner'
    },
    {
      title: 'Projects Module ',
      description: 'This video explains how to use the the Project module in RegScale.',
      url: 'https://www.youtube.com/embed/Pgm2LPuObMc',
      roles: 'auditor, practicioner'
    },
    {
      title: 'Security Plan ',
      description: 'This video explains how to use the Security Plan module in RegScale.',
      url: 'https://www.youtube.com/embed/MnK2nnmxvk4',
      roles: 'auditor, practicioner,executive '
    },
    {
      title: 'Case Management',
      description: 'This video explains how to use the Case Management module in RegScale.',
      url: 'https://www.youtube.com/embed/aXvj2RJnmEc',
      roles: 'practicioner'
    },
    {
      title: 'Implementor Modules',
      description: 'This video explains the implementor modules, Requirements and Security Control Implementations, and how they function in RegScale.',
      url: 'https://www.youtube.com/embed/oxBnU_gS_RM',
      roles: 'practicioner'
    },
    {
      title: 'Data Calls Module',
      description: 'This video explains how to use the Data Calls module in RegScale.',
      url: 'https://www.youtube.com/embed/2NUytAcWzLY',
      roles: 'practicioner'
    },
    {
      title: 'Causal Analysis Module',
      description: 'This video explains how to use the Causal Analysis module in RegScale.',
      url: 'https://www.youtube.com/embed/EzbX4RFen4w',
      roles: 'practicioner'
    }
  ];

  constructor() { }

  //returns the list of videos
  getVideos() {
    this.videos.sort((a, b) => a.title < b.title ? -1 : a.title > b.title ? 1 : 0);
    return this.videos;
  }

  //returns only videos matching the specified role
  getVideosByRole(strRole) {
    if (strRole != '') {
      var subset = this.videos.filter(x => x.roles.indexOf(strRole) >= 0);
      return subset;
    } else {
      return this.videos;
    }
  }
}
